<template>
  <div>
    <section id="last-work" class="cr-section about-area  section-padding-lg " >
      <div class="container">
        <div class="section-title">
          <h1 class="text-center">{{$t('Portfólió')}}</h1>
        </div>
        <Loading :loaded="loaded"></Loading>
        <div class="row portfolios-wrapper portfolios-zoom-button-holder" v-if="loaded">
          <div class="col-lg-4 col-md-6 col-12 portfolio-item portfolio-filter-graphic portfolio-filter-design"
               v-for="gallery in filteredGallery" v-bind:key="'gallery-'+gallery.id">
            <div class="portfolio">
              <div class="portfolio-image">
                <ImageLazy :image="gallery.lead_image" :alt="gallery.description" :title="gallery.name"></ImageLazy>
              </div>
              <div class="portfolio-content">
                <h5><router-link :to="menuPrefix+'/galeria/'+gallery.slug">{{gallery.name}}</router-link></h5>
                <h6><router-link :to="menuPrefix+'/galeria/'+gallery.slug">{{$t(gallery.category)}}</router-link></h6>
              </div>
            </div>
            <p class="text-center p-2" v-html="gallery.description"></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ImageLazy from '../ImageLazy'
import Loading from '../Loading'
export default {
  name: 'Portfolio',

  data () {
    return {
      galleries: [],
      categories: [],
      selectedCategory: null,
      loaded: false
    }
  },
  computed: {
    filteredGallery: function () {
      if (this.selectedCategory) {
        return this.galleries.filter(item => item.category === this.selectedCategory)
      } else {
        return this.galleries
      }
    },
    menuPrefix: function () {
      return this.$translate.locale === 'en' ? '/en' : ''
    }
  },

  watch: {
    selectedCategory: function (val, old) {
      if (val !== old) {
        const self = this
        self.loaded = false
        setTimeout(function () {
          self.loaded = true
        }, 1000)
      }
    }
  },
  components: {ImageLazy, Loading},
  mounted () {
    this.getHomeGallery()
    const self = this
    self.$eventHub.$on('language-changed', function () {
      self.getHomeGallery()
    })
  },
  methods: {
    getHomeGallery () {
      this.axios.get(this.$host + 'portfolio').then(resp => {
        this.galleries = resp.data.data
        this.categories = resp.data.categories
        this.loaded = true
      }).catch(() => {
        this.loaded = true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/portfolio/Portfolio.vue